/**
 * Loads and caches the shared game presentation UI strings.
 * Used by every game's pairing/presenter UI so the wording stays
 * consistent across the library.
 */
export function useGamePresentationUI() {
  return useAsyncData('game-presentation-ui', () =>
    queryCollection('gamePresentationUi').first(),
  )
}
